export default __webpack_public_path__ + "353a3bb93ba34c9b047610960d97fbb4.woff2";